/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SkincareInputs */

const en_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skincare`)
};

const es_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuidado de la piel`)
};

const fr_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soin de la peau`)
};

const de_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hautpflege`)
};

const ja_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキンケア`)
};

const zh_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`护肤品`)
};

const ar_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناية بالبشرة`)
};

const id_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perawatan Kulit`)
};

const it_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cura della Pelle`)
};

const ru_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уход за кожей`)
};

const pt_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuidados com a Pele`)
};

const ko_val_skincare = /** @type {(inputs: Val_SkincareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스킨케어`)
};

/**
* | output |
* | --- |
* | "Skincare" |
*
* @param {Val_SkincareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_skincare = /** @type {((inputs?: Val_SkincareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SkincareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_skincare(inputs)
	if (locale === "es") return es_val_skincare(inputs)
	if (locale === "fr") return fr_val_skincare(inputs)
	if (locale === "de") return de_val_skincare(inputs)
	if (locale === "ja") return ja_val_skincare(inputs)
	if (locale === "zh") return zh_val_skincare(inputs)
	if (locale === "ar") return ar_val_skincare(inputs)
	if (locale === "id") return id_val_skincare(inputs)
	if (locale === "it") return it_val_skincare(inputs)
	if (locale === "ru") return ru_val_skincare(inputs)
	if (locale === "pt") return pt_val_skincare(inputs)
	return ko_val_skincare(inputs)
});